export default () => ({
  refreshToken: null,
  token: null,
  user: {
    username: null,
    firstName: null,
    lastName: null,
  },
});
